import { JETTON_GROWTH_RATE } from '../ui/multiplier/constants';

/**
 * Abstraction over the multiplier growth function (DIP). Pure: given elapsed
 * time it returns the multiplier, with no knowledge of clocks or rendering.
 */
export interface IGrowthCurve {
  /** Multiplier after `elapsedMs` milliseconds of flight. */
  at(elapsedMs: number): number;
}

/** Floor to two decimals to match the displayed precision. */
function floor2(value: number): number {
  return Math.floor(value * 100) / 100;
}

/**
 * Exponential growth: m(t) = e^(rate * t), floored to 2 decimals.
 * Must stay in sync with backend app/jetton/constants.py.
 */
export class ExponentialGrowthCurve implements IGrowthCurve {
  constructor(private readonly rate: number = JETTON_GROWTH_RATE) {}

  at(elapsedMs: number): number {
    return floor2(Math.exp(this.rate * elapsedMs));
  }
}
